import React from 'react';
import { useLocation } from 'react-router-dom';
import { useGalleryConfig } from '../../context/GalleryConfigContext';
import { useGalleryTheme } from '../../context/GalleryThemeContext';

const GalleryNavigation: React.FC = () => {
  const { config } = useGalleryConfig();
  const { theme } = useGalleryTheme();
  const location = useLocation();

  if (!config) return null;

  // Don't show breadcrumb navigation on home page
  if (location.pathname === '/') return null;

  const getBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/' }];

    if (pathSegments.length > 0) {
      switch (pathSegments[0]) {
        case 'events':
          breadcrumbs.push({ label: 'Galleries', path: '/events' });
          if (pathSegments[1]) {
            // Would need to fetch event title, for now use ID
            breadcrumbs.push({
              label: 'Gallery',
              path: `/events/${pathSegments[1]}`,
            });
          }
          break;
        case 'cart':
          breadcrumbs.push({ label: 'Shopping Cart', path: '/cart' });
          break;
        case 'checkout':
          breadcrumbs.push({ label: 'Checkout', path: '/checkout' });
          break;
        case 'account':
          breadcrumbs.push({ label: 'My Account', path: '/account' });
          break;
        case 'login':
          breadcrumbs.push({ label: 'Sign In', path: '/login' });
          break;
        case 'register':
          breadcrumbs.push({ label: 'Sign Up', path: '/register' });
          break;
        default:
          breadcrumbs.push({
            label: pathSegments[0].charAt(0).toUpperCase() + pathSegments[0].slice(1),
            path: `/${pathSegments[0]}`,
          });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav
      className="py-3 border-b"
      style={{
        backgroundColor: theme.colors.background,
        borderBottomColor: theme.colors.border,
      }}
    >
      <div className="container mx-auto px-4">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.path} className="flex items-center">
              {index > 0 && (
                <span className="mx-2" style={{ color: theme.colors.text.muted }}>
                  /
                </span>
              )}
              {index === breadcrumbs.length - 1 ? (
                <span style={{ color: theme.colors.text.primary }}>{crumb.label}</span>
              ) : (
                <a
                  href={crumb.path}
                  className="hover:underline"
                  style={{ color: theme.colors.primary }}
                >
                  {crumb.label}
                </a>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default GalleryNavigation;
